import predefinedColorTemplate from './predefinedColor.html';

const predefinedColor = () => ({
    template: predefinedColorTemplate,
    scope: {
        colors: '=',
        predefinedColors: '=',
        selectedPacket: '=',
        setColorFromPredefined: '=',
    },
    controller: 'PredefinedColorCtrl',
    controllerAs: 'predefinedColor',
    bindToController: true,
});

export default predefinedColor;